<template>
  <div
    ref="blockWrapper"
    :class="['buttons-bottom-header__item favorites-header _with-popup', {'_with-popup--active': isPopupShow}]"
    data-list-type="jsFavoriteList"
  >
    <a href="/favorites/" class="buttons-bottom-header__link">
      <div class="buttons-bottom-header__icon">
        <svg
          width="22" height="21"
          viewBox="0 0 22 21" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4084 1.80165L14.142 7.58318L20.4409 8.12043C20.8778 8.15789 20.7726 8.33698 20.4409 8.62187L15.9461 13.0936L17.3779 19.2074C17.4771 19.6322 17.4222 19.7257 17.0469 19.5L11.2249 16.4995L5.54688 19.5C5.17057 19.7248 4.9726 19.6313 5.07189 19.2074L6.50365 13.0936L2.0367 8.62187C1.70507 8.33698 1.56994 8.1569 2.00781 8.11944L8.30675 7.5822L11.0005 1.80165C11.1713 1.39945 11.2376 1.39945 11.4084 1.80165Z"
            stroke="#474747" stroke-width="2"
          />
        </svg>
        <div class="items-count" style="display: none">1</div>
        <div v-if="countItems > 0" class="buttons-bottom-header__icon-count items-count__show">
          {{ countItems }}
        </div>
      </div>
      <span>Избранное</span>
    </a>
    <div class="buttons-bottom-header__item-popup">
      <div class="buttons-bottom-header__added-products jsFavoriteList">
        <template v-for="(item, key) in items">
          <header-product
            :key="`header-favorite-product-${key}`"
            :item="item"
            @deleteItem="deleteItem"
          />
        </template>
      </div>
      <div class="buttons-bottom-header__btn-wrapper">
        <a class="buttons-bottom-header__btn _btn" href="/favorites/">
          <p>В избранное</p>
          <span />
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import HeaderProduct from '@/components/header-product.vue';
import initHeaderButtonsEffect from '../../../assets/js/modules/function-header-buttons-effect';
import { storageGet, storageSet } from '../../../assets/js/modules/libs/localStorage';

export default {
  name: 'app',
  components: {
    HeaderProduct,
  },
  data() {
    return {
      items: {},
      isPopupShow: false,
      isFirstLoad: true,
    };
  },
  computed: {
    countItems() {
      if (this.items) return Object.keys(this.items).length;
      return 0;
    },
    isSessionIdUpdate() {
      return window.isSessionIdUpdate;
    },
  },
  watch: {
    countItems(newValue, oldValue) {
      if (newValue > oldValue && !this.isFirstLoad && !this.isSessionIdUpdate) {
        this.isPopupShow = true;
        setTimeout(() => {
          this.isPopupShow = false;
        }, 2000);
      }
      if (this.isFirstLoad) this.isFirstLoad = false;
    },
  },
  mounted() {
    this.items = storageGet('favorites');
    if (!this.items?.length) {
      queueMicrotask(() => {
        this.isFirstLoad = false;
      });
    }

    initHeaderButtonsEffect(document.querySelector('[data-list-type="jsFavoriteList"]'));
    this.handlerChanges();
  },
  methods: {
    handlerChanges() {
      window.addEventListener('favoriteUpdate', () => {
        this.items = storageGet('favorites');
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.items = storageGet('favorites');
          window.updateFavorites();
        }
      });
    },
    async deleteItem(id) {
      const itemsIds = Object.keys(this.items);
      const queryString = new URLSearchParams({
        id,
        itemsIds: JSON.stringify(itemsIds),
      });
      const response = await fetch(`/local/ajax/favorites/deleteItem.php?${queryString}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        const res = await response.json();
        const { items } = res;

        if (Array.isArray(items) && !items.length) {
          this.isPopupShow = false;
          this.$refs.blockWrapper.classList.remove('_with-popup--active');
          setTimeout(() => {
            this.updateItems(items);
          }, 500);
        } else {
          this.updateItems(items);
        }
      }
    },
    updateItems(items) {
      this.items = items;
      storageSet({ key: 'favorites', value: items });
      storageSet({ key: 'lastTimeFavoritesUpdate', value: Date.now() });
      window.updateFavorites();
    },
  },
};
</script>
